import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "audio-upload-prompt__check-icon-wrapper"
}
const _hoisted_2 = { class: "audio-upload-prompt__heading" }
const _hoisted_3 = { class: "audio-upload-prompt__text audio-upload-prompt__subheading" }

import { ref, computed, toRefs, watch } from 'vue'
import AudioIcon from '@/assets/AudioIcon.svg'
import TinyButton from '@/components/preview/TinyButton.vue'
import SolidCheckCircle from '@/assets/SolidCheckCircle.svg'
import Spinner from '@/components/common/Spinner.vue'
import { AudioLoadState } from '@/audio/types'
import useWidthLimitedFileName from '@/composables/UseWidthLimitedFileName'
import FileSelector from '@/components/common/FileSelector.vue'
import { audioAccept } from '@/static/file-types'


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioUploadPrompt',
  props: {
    isDragged: { type: Boolean },
    loadState: null,
    fileName: null
  },
  emits: ["fileSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'fileSelected', file: File | string, fileName?: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isDragged: boolean
  loadState: AudioLoadState
  fileName: string
};

_useCssVars(_ctx => ({
  "270ed6fe": (fontSize.value)
}))

const sampleURL = 'https://static.serato.com/visualizer/audio/Serato-Studio-Golden-Hour.mp3'



const {
  isDragged,
  fileName
} = toRefs(props)

const isAudioLoading = computed(() => ['loading', 'loaded'].includes(props.loadState))

// This ref is required to only show the exit animation when dragging has ended. This is only possible to do if we
// activate the animation after the _first_ time that dragging ends - otherwise we end up with the animation on mount
const dragLeave = ref(false)

watch(isDragged, (isDragged) => {
  dragLeave.value = !isDragged
})

const fontSize = ref('14px')
const truncatedFileName = useWidthLimitedFileName(fileName, fontSize)
const heightMediaQuery = window.matchMedia('(min-height: 1080px)')

heightMediaQuery.addEventListener('change', (e) => {
  fontSize.value = e.matches ? '18px' : '14px'
})

const heading = computed(() =>
  isAudioLoading.value
    ? 'Uploading Audio'
    : 'Drop audio here'
)

const subheading = computed(() =>
  isAudioLoading.value
    ? truncatedFileName.value
    : 'mp3 or wav files\n10min | 200MB max'
)



const onFileSelected = (file: File | string, fileName?: string) => {
  emits('fileSelected', file, fileName)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'audio-upload-prompt',
      {
        'audio-upload-prompt--loading': _unref(isAudioLoading),
        'audio-upload-prompt--drag-over': _unref(isDragged),
        'audio-upload-prompt--drag-leave': dragLeave.value
      }
    ])
  }, [
    (!_unref(isAudioLoading))
      ? (_openBlock(), _createBlock(_unref(AudioIcon), {
          key: 0,
          class: "audio-upload-prompt__cta-icon"
        }))
      : (__props.loadState === 'loading')
        ? (_openBlock(), _createBlock(Spinner, {
            key: 1,
            class: "audio-upload-prompt__spinner"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(SolidCheckCircle), { class: "audio-upload-prompt__check-icon" })
          ])),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(heading)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(subheading)), 1),
    _createVNode(FileSelector, {
      accept: _unref(audioAccept),
      onFileSelected: onFileSelected
    }, {
      default: _withCtx(() => [
        (!_unref(isAudioLoading))
          ? (_openBlock(), _createBlock(TinyButton, {
              key: 0,
              class: "audio-upload-prompt__choose-file",
              text: "Choose file",
              "with-background": true
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["accept"]),
    (!_unref(isAudioLoading))
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          class: "audio-upload-prompt__text audio-upload-prompt__link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onFileSelected(sampleURL)))
        }, "Use sample track"))
      : _createCommentVNode("", true)
  ], 2))
}
}

})